<template>
  <div>
    <div class="booking__input" :class="{ 'is-open': showList }" v-click-outside="closeTravellerList">
     
        <label class="booking__input-label">مسافران </label>
        
          <div class="booking__input-inner" @click="showTravellerList">
            <div class="booking__travellers-btn">
              <span v-if="adult > 0" class="booking__travellers-btn-item">
                <span>{{ adult + child + infant }}</span>
                مسافر
              </span>
            </div>
          </div>
        

        <div class="booking__travellers-list" :class="{ 'is-show': showList }">
          <div class="booking__item-header hide-in-desktop">
            <span>انتخاب تعداد مسافران </span>
            <button @click="closeTravellerList">
              <i class="icon-close" />
            </button>
          </div>

          <div class="booking__travellers-items">
            <ul class="booking__passengers">
              <li class="booking__passenger">
                <div class="booking__passenger-right">
                  <span>بزرگسال</span>
                  <label>12 سال به بالا</label>
                </div>

                <div class="booking__passenger-left">
                  <div class=" counter">
                    <button
                      class="counter-button"
                      @click="addPassenger('adult')"
                    >
                      <i class="icon-add"></i>
                    </button>
                    <span>{{ adult }}</span>
                    <button
                      class="counter-button"
                      @click="lowOffPassenger('adult')"
                    >
                      <i class="icon-minus"></i>
                    </button>
                  </div>
                </div>
              </li>

              <li class="booking__passenger">
                <div class="booking__passenger-right">
                  <span>کودک</span>
                  <label>2 تا 12 سال</label>
                </div>

                <div class="booking__passenger-left">
                  <div class=" counter">
                    <button
                      class="counter-button"
                      @click="addPassenger('child')"
                    >
                      <i class="icon-add"></i>
                    </button>
                    <span>{{ child }}</span>
                    <button
                      class="counter-button"
                      @click="lowOffPassenger('child')"
                    >
                      <i class="icon-minus"></i>
                    </button>
                  </div>
                </div>
              </li>

              <li class="booking__passenger">
                <div class="booking__passenger-right">
                  <span>نوزاد</span>
                  <label>10 روز تا 2 سال</label>
                </div>

                <div class="booking__passenger-left">
                  <div class=" counter">
                    <button
                      class="counter-button"
                      @click="addPassenger('infant')"
                    >
                      <i class="icon-add"></i>
                    </button>
                    <span>{{ infant }}</span>
                    <button
                      class="counter-button"
                      @click="lowOffPassenger('infant')"
                    >
                      <i class="icon-minus"></i>
                    </button>
                  </div>
                </div>
              </li>
            </ul>

            <span class="booking__validation" v-if="error.length">{{
              error
            }}</span>
          </div>

          <div class="booking__confirm hide-in-desktop">
            <button
              class="btn btn--primary"
              @click="closeTravellerList"
            >
              تایید
            </button>
          </div>
        </div>
     
    </div>
    <div class="booking__passenger-cabinType hide-in-desktop">
      <select @change="selectCabinType()" v-model="cabinType">
        <option
          v-for="cabinType in cabinTypeList"
          :key="cabinType.key"
          :value="cabinType.cabinTypeNumber"
        >
          {{ cabinType.title }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { clickOutside } from "../../../../Helpers/directives";
import { cabinTypeList } from "../../../../ConstantData/constants";

// select html tag
const root = document.getElementsByTagName("html")[0];

export default {
  name: "Travellers",

  data() {
    return {
      totalPassengerCount: 1,

      minAdult: 1,

      minChild: 0,

      minInfant: 0,

      maxPassengerCount: 9,

      adult: 1,

      child: 0,

      infant: 0,

      cabinTypeList: [...cabinTypeList],

      selectedCabinType: cabinTypeList[0],

      cabinType: 0,

      error: "",

      showList: false,
    };
  },

  methods: {
    // show traveller list
    showTravellerList() {
      this.$emit("scroll-to-booking-section", this.$el);

      if (window.innerWidth < 993) {
        root.classList.add("no-scroll");
      }

      this.showList = true;
    },

    // close traveller list
    closeTravellerList() {
      if (this.showList) {
        this.showList = false;

        if (window.innerWidth < 993) {
          root.classList.remove("no-scroll");
        }

        this.$emit("remove-search-holder-z-index");
      }
    },

    // add passenger function
    addPassenger(passengerType) {
      if (this.totalPassengerCount < this.maxPassengerCount) {
        this.error = "";
        if (passengerType === "adult") {
          this.adult++;
        } else if (passengerType === "infant") {
          if (this.infant < this.adult) {
            this.infant++;
          } else {
            this.error = "تعداد نوزاد نمی تواند بیشتر از تعداد بزرگسال باشد";
          }
        } else {
          this.child++;
        }
        this.totalPassengers();
      } else {
        this.error = "تعداد کل مسافرین نمیتواند بیشتر از 9 نفر باشد";
      }
    },

    // low off passenger function
    lowOffPassenger(passengerType) {
      this.error = "";
      if (passengerType === "adult") {
        if (this.infant < this.adult) {
          this.adult = this.adult > this.minAdult ? this.adult - 1 : this.adult;
        } else {
          this.error = "تعداد بزرگسال نمی تواند کمتر از تعداد نوزاد باشد";
        }
      } else if (passengerType === "infant") {
        this.infant =
          this.infant > this.minInfant ? this.infant - 1 : this.infant;
      } else {
        this.child = this.child > this.minChild ? this.child - 1 : this.child;
      }
      this.totalPassengers();
    },

    // show total passenger
    totalPassengers() {
      this.totalPassengerCount = this.adult + this.child + this.infant;
    },

    // set cabin type on click
    selectCabinType() {
      this.cabinTypeList.map((item) => {
        if (item.cabinTypeNumber === this.cabinType) {
          this.selectedCabinType = item;
        }
      });
    },
  },

  directives: {
    "click-outside": clickOutside,
  },
};
</script>
